export default __webpack_public_path__ + "static/media/Lose.4788cbc8.svg";